import type { TextareaHTMLAttributes } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
}

export default function Textarea({ label, error, className = '', id, ...props }: TextareaProps) {
  const textareaId = id || props.name

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={textareaId} className="block text-sm font-medium text-brand-muted mb-2">
          {label}
          {props.required && <span className="text-accent-teal ml-1">*</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        className={`
          w-full px-[18px] py-[14px]
          bg-white/[0.03] border border-white/[0.1] rounded-lg
          text-brand-light placeholder-[#6b6965]
          focus:outline-none focus:border-accent-teal focus:ring-[3px] focus:ring-accent-teal/10
          transition-all duration-300 ease-out
          resize-y min-h-[150px]
          ${error ? 'border-red-500' : ''}
          ${className}
        `}
        {...props}
      />
      {error && <p className="mt-1.5 text-sm text-red-500">{error}</p>}
    </div>
  )
}
